
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import { supabase } from "@/integrations/supabase/client";

const PASSWORD_SESSION_KEY = "password_gate_passed";

export default function PasswordGate() {
  const [open, setOpen] = useState(!sessionStorage.getItem(PASSWORD_SESSION_KEY));
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!value.trim()) {
      setError("Please enter a password.");
      return;
    }
    
    setLoading(true);
    setError("");
    
    try {
      console.log("Sending password verification request");
      
      // Use Supabase client to call the edge function instead of direct fetch
      const { data, error: functionError } = await supabase.functions.invoke('password-gate', {
        body: { password: value }
      });
      
      if (functionError) {
        console.error("Function error:", functionError);
        throw new Error(functionError.message || "Server error");
      }
      
      console.log("Response received:", data);
      
      if (data.success) {
        sessionStorage.setItem(PASSWORD_SESSION_KEY, "true");
        setOpen(false);
        toast.success("Access granted");
      } else {
        setError(data.message || "Incorrect password.");
      }
    } catch (err) {
      console.error("Password verification error:", err);
      setError("Server error. Please try again.");
      toast.error("Connection error");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-white flex items-center justify-center">
      <form
        onSubmit={handleSubmit}
        className="bg-card border rounded-lg p-8 shadow-lg w-full max-w-xs flex flex-col gap-4"
      >
        <h2 className="text-lg font-semibold text-center">Enter Password</h2>
        <Input
          type="password"
          value={value}
          autoFocus
          onChange={e => setValue(e.target.value)}
          placeholder="Password"
          disabled={loading}
        />
        {error && <div className="text-destructive text-sm">{error}</div>}
        <Button type="submit" className="w-full" disabled={loading}>
          {loading ? "Checking..." : "Unlock"}
        </Button>
        <div className="text-xs text-muted-foreground text-center mt-2">App is password protected</div>
      </form>
    </div>
  );
}
